<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>
<template>
  <div id="app">
    <usertop></usertop>
    <el-main class="usermain">
      <div class="com_task lf">
        <el-radio-group v-model="isCollapse" style="margin-bottom: 20px" @change="radiocount">
          <el-radio-button :label="ix" :key="ix" v-for="(item, ix) in numArr">{{
            ix == "0"
              ? "全部(" + item + ")"
              : ix == "0"
              ? "未开始(" + item + ")"
              : ix == "1"
              ? "及格(" + item + ")"
              : ix == "2"
              ? "不及格(" + item + ")"
              : ix == "4"
              ? "缺考(" + item + ")"
              : ix == "5"
              ? "待阅(" + item + ")"
              : ix == "3"
              ? "满分(" + item + ")"
              : ix == "7"
              ? "补考(" + item + ")"
              : "未开始(" + item + ")"
          }}</el-radio-button>
        </el-radio-group>
      </div>
      <el-input placeholder="请输入内容" v-model="input" class="user_search rf" @change="searchtxt"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
      <div class="clear"></div>
      <div class="userCom">
        <ul>
          <li v-for="(item, ix) in userList" :key="ix" :style="item.states == 4 ? 'opacity:0.6' : ''">
            <div class="userLitsTop">
              <img :src="item.pic" class="lf" />
              <span class="lf userspan">{{ item.create_name }}</span>
              <em class="lf">指派</em>
              <cite class="lf" v-if="item.type == 2">
                <router-link :to="{ path: '/userVideo', query: { id: item.t_id } }">
                  <i class="el-icon-video-play"></i>学习任务
                </router-link></cite>
              <el-tag :key="
                  item.states == 0
                    ? '未开始'
                    : item.states == 1
                    ? '及格'
                    : item.states == 2
                    ? '不及格'
                    : item.states == 3
                    ? '满分'
                    : item.states == 4
                    ? '缺考'
                    : item.states == 5
                    ? '待阅'
                    : '未开始'
                " :type="
                  item.states == 0
                    ? ''
                    : item.states == 1
                    ? 'success'
                    : item.states == 2
                    ? 'danger'
                    : item.states == 3
                    ? 'warning'
                    : item.states == 4
                    ? 'info'
                    : 'warning'
                " class="rf" effect="plain">
                {{
                  item.states == 0
                    ? "未开始"
                    : item.states == 1
                    ? "及格"
                    : item.states == 2
                    ? "不及格"
                    : item.states == 3
                    ? "满分"
                    : item.states == 4
                    ? "缺考"
                    : item.states == 5
                    ? "待阅"
                    : item.states == 6
                    ? '缺考'
                    : "未开始"
                }}
              </el-tag>
            </div>
            <p class="userName">{{ item.title }}</p>
            <p class="userTime">{{ item.s_time }} - {{ item.e_time }}</p>
            <div class="userListBottom">
              <span>考试{{ item.num }}次</span>
              <span>总分{{ item.scores }}</span>
              <span>得分{{ item.grade }}</span>
<!--              <el-link style="position: absolute" :underline="false" v-if="item.video" :href="item.video" target="_blank" type="primary"><span  style="color: #55ACEF !important;">观看视频</span></el-link>-->
              <el-dropdown>
              <span class="el-dropdown-link" v-if="item.video || item.job_video">查看视频<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                <el-dropdown-menu slot="dropdown" style="width: 100px">
                  <el-dropdown-item><el-link :underline="false" v-if="item.video" :href="item.video" target="_blank" type="primary"><span  style="color: #55ACEF !important;">视频1</span></el-link></el-dropdown-item>
                  <el-dropdown-item><el-link :underline="false" v-if="item.job_video" :href="item.job_video" target="_blank" type="primary"><span  style="color: #55ACEF !important;">视频2</span></el-link></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <router-link :to="{ path: '/useranswer', query: { id: item.t_id } }" v-if="item.states == 0" style="position: absolute;">
                开始考试
              </router-link>
              <!-- <router-link :to="{ path: '/parseTest', query: { id: item.t_id } }" v-if="item.states == 1 || item.states == 3">
                查看答案解析
              </router-link> -->
              <router-link :to="{
                  path: '/useranswer',
                  query: { id: item.t_id, rexam: 2 },
                }" v-if="item.states == 2 && item.retake == 1">
                重考
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </el-main>
    <div class="pagination">
      <el-pagination :page-sizes="[8, 20, 32, 48]" :page-size="size" :current-page="page" @size-change="sizechange" @current-change="changePage" layout="sizes,prev, pager, next, total" hide-on-single-page :total="count">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import usertop from "./userTop";
export default {
  name: "index",
  data() {
    return {
      input: "",
      userList: [],
      limit: 20, //一页几条数据
      numArr: [],
      count: 0, //数据总计
      isCollapse: 0,
      page: 1,
      size: 20,
    };
  },
  components: {
    usertop,
  },
  methods: {
    searchtxt() {
      var list = [];
      this.checked = "";
      this.cascaderVal = "";
      this.comview.search(
        this.HOME,
        {
          service: "Mytask.Mytask",
          where: this.input,
          userid: localStorage.getItem("userid"),
          state: this.isCollapse,
        },
        function (res, Message) {
          if (res.data.data.code == 0) {
            for (let i = 0; i < res.data.data.info.info.length; i++) {
              list.push(res.data.data.info.info[i]);
            }
          } else {
            Message.error("没有搜索到该试题");
          }
        }
      );
      this.userList = list;
    },
    changePage(e) {
      this.page = e;
      this.pagetion(this.limit, this.page);
    },
    radiocount(e) {
      var data = [];
      this.input = "";
      var dataUp = {
        service: "Mytask.Mytask",
        userid: localStorage.getItem("userid"),
        state: e,
        page: 1,
        limit: this.limit,
      };
      this.$axios
        .post(this.HOME, this.$qs.stringify(dataUp))
        .then((res) => {
          if (res.data.data.code == 0) {
            for (var i = 0; i < res.data.data.info.info.length; i++) {
              data.push(res.data.data.info.info[i]);
            }
          }
          this.userList = data;
          this.count = parseInt(res.data.data.count);
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
    sizechange(e) {
      this.limit = e;
      this.pagetion(this.limit, this.page);
    },
    pagetion(limit, page) {
      var data = {
        service: "Mytask.Mytask",
        userid: localStorage.getItem("userid"),
        limit: limit,
        page: page,
        state: this.isCollapse,
      };
      var List = [];
      var url = this.HOME;
      this.$axios
        .post(url, this.$qs.stringify(data))
        .then((res) => {
          if (res.data.data.code == 0) {
            for (let i = 0; i < res.data.data.info.info.length; i++) {
              List.push(res.data.data.info.info[i]);
            }
            this.userList = List;
            this.count = parseInt(res.data.data.info.count);
          }
        })
        .catch(function (error) {
          // 请求失败处理
          console.log(error);
        });
    },
  },
  mounted() {
    console.log(this.HOME);
    var data = {
      service: "Mytask.Mytask",
      userid: localStorage.getItem("userid"),
      page: this.page,
      limit: this.limit,
      state: "all",
    };
    var list = [];
    var numList = [];
    this.$axios.post(this.HOME, this.$qs.stringify(data)).then((res) => {
      if (res.data.data.code == 208) {
        if (location.host === "www.junchenlun.com") {
          window.location.href = "https://junchenlun.com/user/";
        } else {
          this.$message.warning("测试版请从分享课进入!");
        }
      }
      this.count = parseInt(res.data.data.info.count);
      for (var i = 0; i < res.data.data.info.info.length; i++) {
        list.push(res.data.data.info.info[i]);
      }
      for (let n in res.data.data.info.num) {
        numList.push(res.data.data.info.num[n]);
      }
      this.userList = list;
      this.numArr = numList;
      // console.log(this.numArr);
    });
  },
};
</script>

<style>
@import "../../assets/css/common.css";
@import "../../assets/css/task.css";
@import "../../assets/css/user.css";
</style>
<style>
.pagination {
  margin-top: 20px;
  float: right;
}
.pagination .el-pager li {
  border: 1px solid #444;
  border-radius: 4px;
  margin-left: 8px;
  color: #444;
}
.pagination .btn-next {
  margin-left: 8px;
}
.pagination .el-pagination__total {
  float: right;
  margin-left: 10px;
}
.pagination .btn-prev,
.pagination .btn-next {
  border: 1px solid #444;
  border-radius: 4px;
  padding: 0;
  color: #444;
}
.pagination .el-pager .active,
.el-pager li:hover {
  border-color: #55acef;
  color: #55acef;
}
.pagination .el-pager li.active + li:hover {
  border-left: 1px solid #55acef;
}
.pagination .el-pager li.active + li {
  border-left: 1px solid #444;
}
.pagination .el-pagination__sizes {
  float: right;
}
.userCom li .userName {
  font-size: 18px;
  color: #000;
  margin-top: 14px;
  width: 343px;
  margin-left: 0;
  overflow: hidden;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/index.vue